import React from 'react';
import PropTypes from 'prop-types';

var Day = function Day(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'date-picker-content-day' : _ref$className,
      _ref$date = _ref.date,
      date = _ref$date === void 0 ? '' : _ref$date;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-testid": "datepicker-day-".concat(date)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, "-half"),
    "data-testid": "datepicker-day"
  }, date));
};

Day.propTypes = {
  className: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Day;
//# sourceMappingURL=DatePickerDay.js.map
